module.exports = __webpack_public_path__ + "static/team-image-1-26d9cccad5f0844c15fa779400bf5484.png";